// @flow
// import React from 'react';
//
// type Props = {
// 	match: Object
// }
//
// const Help = (props: Props) => {
// 	const { match } = props;
// 	return (
// 		<div>
// 			<h1>Help - {match.params.section}</h1>
// 		</div>
// 	);
// };
import { redirectTo } from '../utils/url';

const Help = () => {
	const fantasy_url = process.env.REACT_APP_ABSPATH || false,
		fantasy_help_url = fantasy_url ? fantasy_url + 'help/draft/guidelines' : false;

	redirectTo(fantasy_help_url || '/leagues');
	return null;
};
export default Help;


// WEBPACK FOOTER //
// ./src/pages/Help.js